import Bestilltid from "./Betilltid";
import './scss/_hero.css';

export default function HeroSection() {
    return (
        <section id="hero">
            <div className="cs-container">
                <div className="cs-flex-group">
                    <div className="hero-title">
                        <h1>
                            <span>Trygg fotterapi</span>
                            <p className="h1-lead">i Samnanger og nær områder</p>
                        </h1>
                        <p className="hero-lead">
                            Autorisert fotterapeut med fokus på trygg og profesjonell behandling.
                        </p>
                        <div className="hero-btn">
                           <Bestilltid/>
                        </div>

                    </div>
                </div>
            </div>
            <picture className="cs-picture">
                <source media="(max-width: 600px)" srcSet="../hero2.jpg"/>
                <source media="(min-width: 601px)" srcSet="../hero2.jpg"/>
                <img loading="lazy" decoding="async" src="../hero2.jpg" alt="mountains" width="2250" height="1500" aria-hidden="true" />
            </picture>
        </section>
    );
}